module.exports = __webpack_public_path__ + "img/h2s.474a57df.svg";